import { atom, selector } from "recoil";

import { DataType, History } from "@types";

import { filterdDataState } from "./filterddata";

export const selectedDetailIdState = atom<number>({
  key: "selectedDetailId",
  default: 0,
});

export const selectedDetailDataState = selector<DataType>({
  key: "selectedDetailData",
  get: ({ get }) => {
    const data = get(filterdDataState);
    const index = data.findIndex(
      (value) => value.id === get(selectedDetailIdState)
    );

    return data[index];
  },
});

export const selectedDetailChartDataState = selector<History[]>({
  key: "selectedDetailChartData",
  get: ({ get }) => {
    const data = get(selectedDetailDataState).histories;
    const next = data.filter((v, i, arr) => {
      const twoWeekDivision = Math.round(arr.length / 14);
      const pointNum = Math.round(
        arr.length / (arr.length < 100 ? twoWeekDivision : 6)
      );

      const isLastSevenItem = arr.length - 8 < i;
      const isLastItem = arr.length - 1 === i;
      const isEveryPointItem = i % pointNum === 0;

      return isLastSevenItem && isLastItem ? true : isEveryPointItem;
    });

    return data.length < 1 ? data : next;
  },
});
